import VerticalOverflowText from './VerticalOverflowText';

export default VerticalOverflowText;
